<template>
  <vs-table
    no-data-text="No tienes distribuciones con copia"
    :data="copies"
    class="table"
  >
    <template slot="thead">
      <vs-th>Distribución</vs-th>
      <vs-th>Lista Distribución</vs-th>
      <vs-th>Extra</vs-th>
      <vs-th>Acciones</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="copy" v-for="(copy, indextr) in data" :key="indextr">
        <vs-td :data="copy.copySubjectType.label">
          {{copy.copySubjectType.label}}
        </vs-td>
        <vs-td :data="copy.copySubject.label">
          {{copy.copySubject.label}}
        </vs-td>
        <vs-td
          v-if="copy.copySubjectTypeDigitalDoc.label"
          :data="copy.copySubjectTypeDigitalDoc.label"
        >
          {{copy.copySubjectTypeDigitalDoc.label}}
          <small class="d-block">institución</small>
        </vs-td>
        <vs-td :data="copy.providence">
          <span v-if="copy.providence">
            {{providencesMap[copy.providence]}}
          </span>
          <span v-if="copy.providenceExpiration">
            - {{copy.providenceExpiration}}
          </span>
          <small v-if="copy.providence" class="d-block">providencia</small>
        </vs-td>
        <vs-td>
          <vs-icon
            class="cursor-pointer"
            icon="remove_circle_outline"
            size="small"
            v-tooltip="'Eliminar'"
            color="danger"
            @click="deleteCopy(copy)"
          />
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ProvidencesMap from '@/febos/chile/dnt/mixins/ProvidencesMap';

export default {
  data() {
    return {
      providencesMap: ProvidencesMap,
    };
  },
  methods: {
    deleteCopy(copyToDelete) {
      this.$emit('removeCopy', copyToDelete);
    }
  },
  props: {
    copies: {
      type: Array,
      required: true,
      default: () => []
    },
  }
};
</script>
